module.exports = __webpack_public_path__ + "img/afip.f8bc150f.png";